import { testimonials } from '@/mocks/testimonials';

const starRating = (rating: number) => {
  return Array.from({ length: 5 }, (_, i) => (
    <i
      key={i}
      className={`text-sm ${i < rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
    ></i>
  ));
};

export default function Testimonials() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20" id="testimonials">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-3/5">
            <div className="flex items-center gap-2 mb-8">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs text-foreground-500 font-label tracking-wider uppercase">
                读者评价
              </span>
            </div>

            <div className="space-y-10">
              {testimonials.map((item) => (
                <article key={item.id} className="border-b border-background-200 pb-8 last:border-b-0">
                  <blockquote className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground-950 leading-relaxed mb-5">
                    &ldquo;{item.content}&rdquo;
                  </blockquote>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                      <img
                        src={item.avatar}
                        alt={item.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div className="flex flex-col">
                      <span className="text-sm font-label font-semibold text-foreground-950">
                        {item.name}
                      </span>
                      <div className="flex items-center gap-1.5">
                        <div className="flex items-center">
                          {starRating(item.rating)}
                        </div>
                        <span className="text-xs text-foreground-400">· {item.platform}</span>
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className="lg:w-2/5 hidden lg:block">
            <div className="relative rounded-2xl overflow-hidden h-full min-h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reader%20portrait%2C%20young%20woman%20reading%20webtoon%20on%20tablet%2C%20cozy%20indoor%20setting%2C%20warm%20lighting%2C%20black%20and%20white%20with%20warm%20sepia%20tone%2C%20artistic%20portrait%20photography%2C%20soft%20shadows%2C%20thoughtful%20expression%2C%20elegant%20composition&width=800&height=1000&seq=testimonial-side&orientation=portrait"
                alt="韩国漫画网读者"
                className="w-full h-full object-cover object-right"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}